const { createSelector } = require('reselect')
const selectCategories = (state) =>
  state['marketplace.newCategories'].getCategories

const getCategories = () =>
  createSelector([selectCategories], (prof) => prof.data)

const getCategoriesError = () =>
  createSelector([selectCategories], (prof) => prof.error)

const getCategoriesLoading = () =>
  createSelector([selectCategories], (prof) => prof.loading)



  const selectCategoryProduct = (state) =>
  state['marketplace.newCategories'].getCategoriesProducts

const getCategoriesProduct = () =>
  createSelector([selectCategoryProduct], (prof) => prof.data)

const getCategoriesProductError = () =>
  createSelector([selectCategoryProduct], (prof) => prof.error)

const getCategoriesProductLoading = () =>
  createSelector([selectCategoryProduct], (prof) => prof.loading)



  const selectSubCategory = (state) =>
  state['marketplace.newCategories'].getSubCategories

const getSubCategories = () =>
  createSelector([selectSubCategory], (prof) => prof.data)

const getSubCategoriesError = () =>
  createSelector([selectSubCategory], (prof) => prof.error)

const getSubCategoriesLoading = () =>
  createSelector([selectSubCategory], (prof) => prof.loading)



module.exports = {
  getCategories,
  getCategoriesError,
  getCategoriesLoading,

  getSubCategories,
  getSubCategoriesError,
  getSubCategoriesLoading,

  getCategoriesProduct,
  getCategoriesProductError,
  getCategoriesProductLoading
}
